<template>
  <div>
    <div class="table-cont">
      <div class="table-title">payment history</div>
      <el-table class="table-body" :data="infoList.repayRecordList" style="width: 100%"
                :highlight-current-row="isHightLight">
        <el-table-column type='index' label="number" width="80">
          <template slot-scope="scope">
            <span class="item_index">{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="Actual repayment date" width="120">
          <template slot-scope="scope">{{scope.row.financeReceiptDate | formatDate('YYYY-MM-DD')}}</template>
        </el-table-column>
        <el-table-column label="Amount of actual repayment" width="127">
          <template slot-scope="scope">${{scope.row.financeReceiptSum | addThousandSign(2)}}</template>
        </el-table-column>
        <el-table-column label="Real repayment principal" width="110">
          <template slot-scope="scope">${{scope.row.receiptPrincipal | addThousandSign(2)}}</template>
        </el-table-column>
        <el-table-column label="Interest" width="100">
          <template slot-scope="scope">${{scope.row.receiptInterest | addThousandSign(2)}}</template>
        </el-table-column>
        <el-table-column label="Consulting fee" width="118">
          <template slot-scope="scope">${{scope.row.receiptFee | addThousandSign(2)}}</template>
        </el-table-column>
        <el-table-column label="Liquidated damages" width="80">
          <template slot-scope="scope">${{scope.row.receiptPenalty | addThousandSign(2)}}</template>
        </el-table-column>
        <el-table-column label="Method of withholding" prop="repayOperate"></el-table-column>
      </el-table>
      <el-pagination v-if="infoList.repayRecordList.length > 0" class="pament-list-pagination" :small="isSmall"
                     layout="prev, pager, next" :page-count="infoList.pageCount" :page-size="10"
                     @current-change="changePage" style="text-align: center;"></el-pagination>

    </div>
  </div>
</template>
<script>
  export default {
    props: ['infoList'],
    data () {
      return {
        isSmall: true,
        isHightLight: false,
        index: 1
      }
    },
    methods: {
      changePage (currenPage) {
        this.$emit('getRepayList', currenPage)
      }
    }
  }
</script>
<style lang="scss">
  .table-cont {
    overflow: hidden;
    border-radius: 3px;
    background: #fff;

    .table-title {
      height: 45px;
      overflow: hidden;
      line-height: 50px;
      font-size: 16px;
      color: #34495e;
      text-indent: 18px;
    }

    .pament-list-pagination {
      margin: 15px auto;
    }
  }

  .table-body {
    box-sizing: border-box;
    border: none;

    &:before {
      display: none;
    }

    &:after {
      display: none;
    }

    td {
      /*border-bottom: 1px solid #F6F6F6;*/
      border-bottom: none;
    }

    th.is-leaf {
      border-bottom: none;
      overflow: hidden;
      height: 27px;
      background: none;
    }

    .cell {
      text-align: center;
      line-height: 59px;
      font-size: 14px;
      font-weight: bold;
    }

    th .cell {
      font-size: 12px;
      color: #007bff;
      line-height: 27px;
      background: none;
    }

    .item_index {
      display: inline-block;
      border-radius: 2px;
      width: 25px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      color: $white;
      font-size: 12px;
      font-weight: normal;
      background: #cdd8dc;
    }

    .el-table__body-wrapper {
      tr {
        position: relative;
        &:not(:last-child) {
          td:first-child:after {
            content: '';
            position: absolute;
            left: 13px;
            height: 1px;
            width: 846px;
            background-color: #F6F6F6;
            z-index: 100;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// RepaymentList.vue?359f9b10